import { render, staticRenderFns } from "./ChallengeModal.vue?vue&type=template&id=06907770"
import script from "./ChallengeModal.vue?vue&type=script&lang=js"
export * from "./ChallengeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports